/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  GetOrganizationDetailsParams,
  GetOrganizationResponseDto,
  UpdateConnectionAutoMembershipRequestDto,
  UpdateOrganizationLanguageRequestDto
} from '.././model';

import { customAxiosInstance } from '../../axios/axiosInstance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get the organization information
 */
export const getOrganizationDetails = (
    params?: GetOrganizationDetailsParams,
 options?: SecondParameter<typeof customAxiosInstance>,signal?: AbortSignal
) => {
      
      
      return customAxiosInstance<GetOrganizationResponseDto>(
      {url: `/organization`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetOrganizationDetailsQueryKey = (params?: GetOrganizationDetailsParams,) => {
    return [`/organization`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOrganizationDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(params?: GetOrganizationDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationDetails>>> = ({ signal }) => getOrganizationDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationDetails>>>
export type GetOrganizationDetailsQueryError = null


export function useGetOrganizationDetails<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(
 params: undefined |  GetOrganizationDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDetails>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDetails<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(
 params?: GetOrganizationDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganizationDetails>>,
          TError,
          Awaited<ReturnType<typeof getOrganizationDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDetails<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(
 params?: GetOrganizationDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the organization information
 */

export function useGetOrganizationDetails<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(
 params?: GetOrganizationDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOrganizationDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(params?: GetOrganizationDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationDetails>>> = ({ signal }) => getOrganizationDetails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganizationDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationDetails>>>
export type GetOrganizationDetailsSuspenseQueryError = null


export function useGetOrganizationDetailsSuspense<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(
 params: undefined |  GetOrganizationDetailsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDetailsSuspense<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(
 params?: GetOrganizationDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganizationDetailsSuspense<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(
 params?: GetOrganizationDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the organization information
 */

export function useGetOrganizationDetailsSuspense<TData = Awaited<ReturnType<typeof getOrganizationDetails>>, TError = null>(
 params?: GetOrganizationDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getOrganizationDetails>>, TError, TData>>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetOrganizationDetailsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Update organization language
 */
export const OrganizationsController_updateOrganizationLanguage = (
    updateOrganizationLanguageRequestDto: UpdateOrganizationLanguageRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/organization`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationLanguageRequestDto
    },
      options);
    }
  


export const getOrganizationsControllerUpdateOrganizationLanguageMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof OrganizationsController_updateOrganizationLanguage>>, TError,{data: UpdateOrganizationLanguageRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof OrganizationsController_updateOrganizationLanguage>>, TError,{data: UpdateOrganizationLanguageRequestDto}, TContext> => {

const mutationKey = ['organizationsControllerUpdateOrganizationLanguage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof OrganizationsController_updateOrganizationLanguage>>, {data: UpdateOrganizationLanguageRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  OrganizationsController_updateOrganizationLanguage(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OrganizationsControllerUpdateOrganizationLanguageMutationResult = NonNullable<Awaited<ReturnType<typeof OrganizationsController_updateOrganizationLanguage>>>
    export type OrganizationsControllerUpdateOrganizationLanguageMutationBody = UpdateOrganizationLanguageRequestDto
    export type OrganizationsControllerUpdateOrganizationLanguageMutationError = null | null | null

    /**
 * @summary Update organization language
 */
export const useOrganizationsControllerUpdateOrganizationLanguage = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof OrganizationsController_updateOrganizationLanguage>>, TError,{data: UpdateOrganizationLanguageRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof OrganizationsController_updateOrganizationLanguage>>,
        TError,
        {data: UpdateOrganizationLanguageRequestDto},
        TContext
      > => {

      const mutationOptions = getOrganizationsControllerUpdateOrganizationLanguageMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * @summary Update auto-membership status for a connection
 */
export const updateAutoMembershipStatus = (
    connectionId: string,
    updateConnectionAutoMembershipRequestDto: UpdateConnectionAutoMembershipRequestDto,
 options?: SecondParameter<typeof customAxiosInstance>,) => {
      
      
      return customAxiosInstance<null>(
      {url: `/organization/connections/${connectionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateConnectionAutoMembershipRequestDto
    },
      options);
    }
  


export const getUpdateAutoMembershipStatusMutationOptions = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAutoMembershipStatus>>, TError,{connectionId: string;data: UpdateConnectionAutoMembershipRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAutoMembershipStatus>>, TError,{connectionId: string;data: UpdateConnectionAutoMembershipRequestDto}, TContext> => {

const mutationKey = ['updateAutoMembershipStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAutoMembershipStatus>>, {connectionId: string;data: UpdateConnectionAutoMembershipRequestDto}> = (props) => {
          const {connectionId,data} = props ?? {};

          return  updateAutoMembershipStatus(connectionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAutoMembershipStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateAutoMembershipStatus>>>
    export type UpdateAutoMembershipStatusMutationBody = UpdateConnectionAutoMembershipRequestDto
    export type UpdateAutoMembershipStatusMutationError = null | null | null

    /**
 * @summary Update auto-membership status for a connection
 */
export const useUpdateAutoMembershipStatus = <TError = null | null | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAutoMembershipStatus>>, TError,{connectionId: string;data: UpdateConnectionAutoMembershipRequestDto}, TContext>, request?: SecondParameter<typeof customAxiosInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAutoMembershipStatus>>,
        TError,
        {connectionId: string;data: UpdateConnectionAutoMembershipRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateAutoMembershipStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    